export enum InsightsIABadgeVariant {
  Primary = "Primary",
  Success = "Success",
  Critical = "Critical",
  Warning = "Warning",
  Infos = "Info"
}
